import promiseHero from "../../../../img/web/knowus/promise/promise_wd.jpeg";
import { Target, Scale, Globe2, Handshake, Compass, Layers, Zap } from "lucide-react";
import { useTranslation } from "../../../../i18n/useTranslation";

const ICONS = [Target, Scale, Globe2, Handshake, Compass, Layers, Zap];

const Promises = () => {
  const { t } = useTranslation();
  const items = t("promises.items");

  return (
    <div id="promise" className="band-b scroll-mt-24">
      <img className="w-full block" src={promiseHero} alt="" />
      <h1 className="text-center">{t("promises.headingLine1")}<br />{t("promises.headingLine2")}</h1>
      <div className="max-w-xl mx-auto text-center pt-2 px-5">
        <p className="mini">{t("promises.intro")}</p>
      </div>

      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 px-5 py-10">
        {items.map((it, i) => {
          const Icon = ICONS[i];
          return (
            <div key={i} className="card-ledger text-center">
              <Icon className="mx-auto" size={40} strokeWidth={1.5} style={{ color: "var(--gold)" }} />
              <div className="pt-2">
                <h4>{it.title}</h4>
                <p className="mini">{it.body}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Promises;
